import React from 'react';

import * as formatter from 'helpers/Formatter';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

export default class ChangeSubscripion extends React.Component {
  state = { showSubChangeDialog: false, action: null };

  changeSubscription = () => {
    let changeAction;
    if (this.state.action === 'activate') {
      changeAction = { activate_subscription: true };
    } else if (this.state.action === 'deactivate') {
      changeAction = { cancel_subscription: true };
    }

    this.props.updateBillingDetails(changeAction).then(() => {
      this.toggleSubChange();
      this.props.getBillingDetails();
    });
  };

  toggleSubChange = action => {
    this.setState({
      showSubChangeDialog: !this.state.showSubChangeDialog,
      action,
    });
  };

  render() {
    const { canceled_at } = this.props;
    const canceled_at_date = formatter.toFriendlyDateString(new Date(canceled_at * 1000));

    let titleText, submitText, cancelText, bodyText;
    if (this.state.action === 'deactivate') {
      titleText = submitText = 'Cancel Account';
      cancelText = 'Go Back';
      bodyText =
        'Cancelling your subscription will result in a loss of access to all yuhu services at the end of your current billing period. All data will be preserved if you choose to reactive your account.';
    } else if (this.state.action === 'activate') {
      titleText = submitText = 'Reactivate Account';
      cancelText = 'Go Back';
      bodyText =
        'Reactivating your account will result in a new subscription being created starting today as the start of the billing cycle. If your account is cancelled but has not yet expired then reactivating will undo the cancellation.';
    }

    return (
      <div>
        {canceled_at ? (
          <div>
            <strong>Subscription cancelled for {canceled_at_date}</strong>
            <button
              type="button"
              className="link-button"
              onClick={() => this.toggleSubChange('activate')}
            >
              <h5 style={{ marginTop: '0' }}>Reactivate Account</h5>
            </button>
          </div>
        ) : (
          <button
            type="button"
            className="link-button"
            onClick={() => this.toggleSubChange('deactivate')}
          >
            <h5 style={{ marginTop: '0' }}>Cancel Account</h5>
          </button>
        )}

        <Dialog
          disableBackdropClick
          title={titleText}
          open={this.state.showSubChangeDialog}
          onRequestClose={this.toggleSubChange}
          titleStyle={{
            textAlign: 'center',
            fontSize: '28px',
          }}
          bodyStyle={{
            padding: '0px 25px 10px 25px',
            textAlign: 'center',
            color: 'rgba(78, 78, 78, 0.85)',
            fontSize: '16px',
            overflow: 'auto',
          }}
          contentStyle={{
            width: '50%',
            paddingBottom: '10px !important',
          }}
          actionsContainerStyle={{
            paddingLeft: '25px',
            paddingRight: '25px',
          }}
          className="abstract-dialog"
          modal
          actions={[
            <FlatButton
              label={cancelText}
              primary={false}
              onClick={this.toggleSubChange}
              style={{ float: 'left' }}
            />,
            <FlatButton
              label={submitText}
              primary={true}
              keyboardFocused={true}
              onClick={this.changeSubscription}
            />,
          ]}
        >
          <div>
            <p>
              <span style={{ color: '#ff3030' }}>WARNING:</span> {bodyText}
            </p>
          </div>
        </Dialog>
      </div>
    );
  }
}
